import ApiService from '@/services/ApiService'
import PodcastSearchResult from '@/models/PodcastSearchResult'

export default class PodcastService {
  /**
   * Public directory search behind the landing page hero. The backend answers
   * with an empty list when the directory is unreachable, so callers only need
   * to handle "nothing found", not an outage.
   */
  public static async search(q: string): Promise<PodcastSearchResult[]> {
    const response = await ApiService.get<{ data: PodcastSearchResult[] }>('podcasts/search', { q })
    return response.data ?? []
  }
}
